import SpecialDateMasterPage from './SpecialDateMasterPage';

export default SpecialDateMasterPage;
